import React, { PropTypes } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import BorrowingList from '../../shared/BorrowingList';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Table } from '@bibliocommons/base-table';
import { Link } from 'react-router';
import { metadataIdFixer } from '@bibliocommons/utils-link';
import ProgressBar from '@bibliocommons/shared-progress-bar';
import BorrowingHeader from '../../shared/BorrowingHeader';
import AccountMessagesEmptyContentPanel from '../AccountMessagesEmptyContentPanel';

import './AccountMessages.scss';

class AccountMessages extends BcReactComponent {

  static renderMessage(value, index, row) {
    let bibTitle = '';
    if (row.get('metadataId')) {
      bibTitle = (
        <span>
          <Link to={`/item/show/${metadataIdFixer(row.get('metadataId'))}`} title={row.get('bibTitle')}>
            {row.get('bibTitle')}
          </Link>
          <span className="message-subtitle">{row.get('message')}</span>
        </span>
      );
    } else {
      bibTitle = (
        <span className="message-subtitle">
          {row.get('message')}
        </span>
      );
    }

    return bibTitle;
  }

  renderContent() {
    const { messages, fetching } = this.props;

    if (messages.size === 0) {
      return <AccountMessagesEmptyContentPanel fetching={fetching} />;
    }

    const fields = [
      {
        key: 'reason',
        headerKey: 'facets_fine_reason',
        type: 'string'
      },
      { key: 'message',
        headerKey:'facets_message',
        type: 'String',
        transformationMap: AccountMessages.renderMessage
      },
      { key: 'messageDate', id:'message_date', headerKey:'message_date', type: 'Date' }
    ];

    return (
      <div className="title-row">
        <BorrowingHeader
          headingKey="section_title_messages"
          taglineKey="section_tagline_messages" />
        <BorrowingList>
          <Table
            rows={messages}
            fields={fields} />
        </BorrowingList>
      </div>
    );
  }

  render() {
    const { fetching } = this.props;
    return (
      <div className="cp-messages">
        <ProgressBar active={fetching} />
        {this.renderContent()}
      </div>
    );
  }
}

AccountMessages.propTypes = {
  user: ImmutablePropTypes.map,
  messages: ImmutablePropTypes.map.isRequired,
  intl: intlShape.isRequired,
  fetching: PropTypes.bool
};


export default injectIntl(AccountMessages);



// WEBPACK FOOTER //
// ./app/components/borrowing/accountmessages/AccountMessages/AccountMessages.jsx